
import { Component, Vue } from 'vue-property-decorator'

interface TermItem {
  text: string
  subItems?: string[]
}

interface TermSection {
  title: string
  items: TermItem[]
}

@Component({})
export default class ClauseServicePage extends Vue {
  get termsSections(): TermSection[] {
    const t = (key: string) => this.$t(`ClauseService.${key}`) as string
    return [
      { title: t('s0_title'), items: [{ text: t('s0_i0') }, { text: t('s0_i1') }] },
      { title: t('s1_title'), items: [{ text: t('s1_i0') }, { text: t('s1_i1') }, { text: t('s1_i2') }] },
      {
        title: t('s2_title'),
        items: [
          {
            text: t('s2_i0_text'),
            subItems: [
              t('s2_i0_sub0'), t('s2_i0_sub1'), t('s2_i0_sub2'), t('s2_i0_sub3'), t('s2_i0_sub4'),
              t('s2_i0_sub5'), t('s2_i0_sub6'), t('s2_i0_sub7'), t('s2_i0_sub8'), t('s2_i0_sub9'),
            ],
          },
          { text: t('s2_i1') },
          {
            text: t('s2_i2_text'),
            subItems: [t('s2_i2_sub0'), t('s2_i2_sub1'), t('s2_i2_sub2'), t('s2_i2_sub3'), t('s2_i2_sub4')],
          },
        ],
      },
      { title: t('s3_title'), items: [{ text: t('s3_i0') }, { text: t('s3_i1') }] },
      {
        title: t('s4_title'),
        items: [
          { text: t('s4_i0') },
          { text: t('s4_i1_text'), subItems: [t('s4_i1_sub0'), t('s4_i1_sub1'), t('s4_i1_sub2')] },
          { text: t('s4_i2') },
        ],
      },
      {
        title: t('s5_title'),
        items: [{ text: t('s5_i0') }, { text: t('s5_i1') }, { text: t('s5_i2') }, { text: t('s5_i3') }],
      },
      { title: t('s6_title'), items: [{ text: t('s6_i0') }, { text: t('s6_i1') }] },
      { title: t('s7_title'), items: [{ text: t('s7_i0') }, { text: t('s7_i1') }] },
    ]
  }

  created() {
    this.$setNavInfo({
      title: this.$t('ClauseService.pageTitle') as string,
      showNavBar: true,
    })
  }
}
